<template>
    <div>
        <ion-item :class="{ '-no-label': showLabel ? false : true }">
            <ion-label position="floating" v-show="showLabel">{{
                label
            }}</ion-label>
            <ion-select
                :placeholder="placeholder"
                :value="value"
                @ionChange="
                    $event.detail.value
                        ? $emit('input', $event.detail.value)
                        : false
                "
                :multiple="multiple"
                cancel-text="Abbrechen"
                :interface-options="interfaceOptions"
                :interface="interfaceValue"
                :disabled="disabled"
            >
                <slot></slot>
            </ion-select>
        </ion-item>
        <input-error v-if="hasInputErrorField" :id="id"></input-error>
    </div>
</template>

<script>
import InputError from "./InputError";

export default {
    components: {
        InputError,
    },
    props: {
        value: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: "",
        },
        placeholder: {
            type: String,
            required: false,
        },
        id: {
            type: String,
            required: true,
        },
        multiple: {
            type: Boolean,
            required: false,
            default: false,
        },
        hasInputErrorField: {
            type: Boolean,
            required: false,
            default: true,
        },
        interfaceOptions: {
            type: Object,
            required: false,
            default: () => {
                return {};
            },
        },
        interfaceValue: {
            type: String,
            required: false,
            default: "alert",
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        showLabel: {
            type: Boolean,
            required: false,
            default: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.md {
    .label-floating,
    .label-stacked {
        padding-top: 4px;
    }
    ion-select {
        --padding-top: 15px;
    }
}
.ios {
    ion-select {
        --padding-top: 13px;
    }
}

ion-item.-no-label {
    --min-height: auto;
}
ion-label {
    opacity: 0.33;
}
.item-has-value {
    &.md {
        .label-floating,
        .label-stacked {
            padding-top: 8px;
        }
        ion-select {
            --padding-top: 8px;
        }
    }
    &.ios {
        ion-select {
            --padding-top: 8px;
        }
    }
    ion-label {
        opacity: 1;
    }
}
</style>
